import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { isAxiosError, CoreBaseException, CoreBaseDataException } from '../apis/service/exception';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let CoreBasicHttp = class CoreBasicHttp extends HttpServiceHelper {
    constructor(httpClient, errorHandlerService, authService) {
        super(errorHandlerService);
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.authService = authService;
        this.configErrorHandler();
    }
    getAuthService() {
        return this.authService.currentUser.id;
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (CoreBaseDataException.is(error)) {
                this._errorDisplayProxy(error.data?.data?.error_message);
                return true;
            }
            if (!CoreBaseException.is(error)) {
                return false;
            }
            const coreBaseError = error.response?.data;
            if (!coreBaseError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            this._errorDisplayProxy(coreBaseError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        config = _.merge({
            headers: {
                'X-API-Version': '2.0',
                'X-User-ID': this.getAuthService(),
            },
        }, config);
        return this.httpClient(config).then(res => {
            const data = res.data;
            if (data.status === false) {
                throw CoreBaseDataException.mark(res);
            }
            return res.data;
        }, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = CoreBaseException.mark(error);
            throw error;
        });
    }
};
CoreBasicHttp = __decorate([
    injectable(),
    __param(0, inject(Symbols.HttpClient)),
    __param(1, inject(Symbols.ErrorHandlerService)),
    __param(2, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CoreBasicHttp);
export { CoreBasicHttp };
